/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction } from '@reduxjs/toolkit';
import { RequestError, SendCommunicationFormValues, StationsTemplatesPreview } from 'types';
import { createActionWithCallback } from '../utils';

export const fetchStationsTemplatesPreview = createActionWithCallback<void, Error>()(
  'stationsTemplatesPreview/fetch',
  (formValues: SendCommunicationFormValues) => ({
    payload: undefined,
    meta: { formValues },
  })
);

export const fetchedStationsTemplatesPreview = createAction(
  'stationsTemplatesPreview/fetched',
  (data?: StationsTemplatesPreview, error?: RequestError) => ({
    payload: error || data,
    error: Boolean(error),
  })
);

export default {
  fetchStationsTemplatesPreview,
  fetchedStationsTemplatesPreview,
};
